const initialState = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
}
function daterangeReducer(state=initialState, action) {
  return state;
}

export default daterangeReducer